import { Panel } from '@hologram-dimension/panel';
import { useAppSelector } from 'common-js/hooks';
import { OrgModel } from 'common-js/models';
import { getSelectedOrg } from 'common-js/reducers/organization/selectors';
import { type FC } from 'react';

const OrgIdPanel: FC = () => {
  const selectedOrg = useAppSelector(getSelectedOrg) || new OrgModel();

  return (
    <div className="OrgIdPanel">
      <Panel>
        <div>
          {selectedOrg.isMyAccount && 'Personal '}Organization ID {selectedOrg.id}
        </div>
      </Panel>
    </div>
  );
};

export default OrgIdPanel;
